/**
 *
 * @param {object} props The component props
 * @param {import('solid-js').JSX.Element} props.children The children to pass
 * @returns {import('solid-js').JSX.Element} A Floating Card
 */
export function FloatingCard(props) {
  return (
    <div className="tw:flex tw:h-min tw:max-w-md tw:flex-col tw:bg-base-100 tw:p-6 tw:slorg-shadow-md">
      {props.children}
    </div>
  );
}
